export default {
  FETCH_TAGS_REQUEST: 'FETCH_TAGS_REQUEST',
  FETCH_TAGS_SUCCESS: 'FETCH_TAGS_SUCCESS',
  FETCH_TAGS_FAILURE: 'FETCH_TAGS_FAILURE'
}
